export const SET_BANNER_AND_HEADER_HEIGHT = "SET_BANNER_AND_HEADER_HEIGHT";
export const SET_HEADER_HEIGHT = "SET_HEADER_HEIGHT";
export const SIGNPOSTINGBAR_VISIBLE = "SIGNPOSTINGBAR_VISIBLE";

export function setBannerAndHeaderHeight(elem, parentElem) {
  const bannerHeight = elem.getBoundingClientRect().height;
  const headerHeight = parentElem
    ? parentElem.getBoundingClientRect().height
    : 0;

  return {
    type: SET_BANNER_AND_HEADER_HEIGHT,
    payload: {
      headerHeight,
      bannerHeight,
    },
  };
}

export function setHeaderHeight(parentElem) {
  const headerHeight = parentElem.getBoundingClientRect().height;

  return {
    type: SET_HEADER_HEIGHT,
    payload: {
      headerHeight,
    },
  };
}

export function setSignpostingBar(isSignpostingBarVisible) {
  return {
    type: SIGNPOSTINGBAR_VISIBLE,
    isSignpostingBarVisible,
  };
}
